import t from"styled-components";import{theme as e}from"../../../../../theme.js";const i=t.div`
  display: flex;
  flex-direction: column;
  gap: ${e.spacing*2}px;
  cursor: pointer;
  align-items: center;
  > img {
    object-fit: cover;
    width: 100%;
    height: auto;
    aspect-ratio: 300/250;
  }
`;export{i as Container};
